import { Chain } from '@/interfaces';

const INFURA_PROJECT_ID = `9f4672791f4f47bfb79db67ea425fbb1`;

export const SUPPORTED_CHAINS: Chain[] = [
  {
    chainId: `0x1`,
    chainName: `Ethereum Mainnet`,
    nativeCurrency: {
      decimals: 18,
      name: `Ether`,
      symbol: `ETH`,
    },
    rpcUrls: [`https://mainnet.infura.io/v3/${INFURA_PROJECT_ID}`],
    iconUrls: [],
  },
  {
    chainId: `0x3`,
    chainName: `Ethereum Ropsten`,
    nativeCurrency: {
      decimals: 18,
      name: `Ether`,
      symbol: `rETH`,
    },
    rpcUrls: [`https://ropsten.infura.io/v3/${INFURA_PROJECT_ID}`],
    iconUrls: [],
  },
  {
    chainId: `0x38`,
    chainName: `Binance Smart Chain`,
    nativeCurrency: {
      decimals: 18,
      name: `Binance Smart Coin`,
      symbol: `BNB`,
    },
    rpcUrls: [`https://bsc-dataseed.binance.org/`],
    iconUrls: [],
  },
  {
    chainId: `0x61`,
    chainName: `Binance Smart Chain Testnet`,
    nativeCurrency: {
      decimals: 18,
      name: `Binance Smart Coin`,
      symbol: `BNB`,
    },
    rpcUrls: [`https://data-seed-prebsc-1-s1.binance.org:8545/`],
    iconUrls: [],
  },
];

export function getChainByChainID(chainId: string | number) {
  return SUPPORTED_CHAINS.find((chain) => +chain.chainId === +chainId);
}
